import { styled } from '@material-ui/core';

import { Typography } from 'shared/components/typography/Typography';

export const Disclaimer = styled(Typography)(({ theme: { palette } }) => ({
  textAlign: 'center',
  color: palette.gray.main,
}));
